//jquery for wordpress
jQuery(document).ready(function($) {

	if($('.slick-tab-content').length > 0) {

		function what_we_do_slider(){
			if($(window).width() > 900) {
				//check before init
				if(!$('.slick-tab-content').hasClass('slick-initialized')) {

					//check if tab-content is slide up
					if($('.tab-content').is(':hidden')) {
						$('.tab-content').slideDown();
					}

					$('.slick-tab-content').slick({
						infinite: false,
						slidesToShow: 1,
						slidesToScroll: 1,
						autoplay: false,
						speed: 300,
						dots: false,
						arrows: false,
					});
				}
			} else {
				//check before unslick
				if($('.slick-tab-content').hasClass('slick-initialized')) {
					$('.slick-tab-content').slick('unslick');
				}

				//check if tab-content is slide down also if is first child
				let i = 0;
				$('.tab-content').each(function() {

					if(i === 0) {
						$(this).siblings('.tab-content-title-mobile').addClass('active');
						$(this).slideDown();
					}
					if($(this).is(':visible') && i !== 0) {
						$(this).slideUp();
						$(this).siblings('.tab-content-title-mobile').removeClass('active');
					}
					i++;
				});


			}
		}

		what_we_do_slider();

		//trigger on resize or screen rotate
		$(window).resize(function() {
			what_we_do_slider();
		});

		if($(window).width() > 899) {
			$('.tab-title').click(function() {
				let slide_id = $(this).attr('data-title-number');
				$('.tab-title').removeClass('active');
				$(this).addClass('active');
				$('.slick-tab-content').slick('slickGoTo', slide_id);
			});
		}




		$('.tab-content-title-mobile').click(function(){
			//$('.tab-content-title-mobile').removeClass('active');


			//$(this).parent(".tab").siblings().find('.tab-content').slideUp();

			if($(this).next(".tab-content").is(':visible')) {

				$(this).next(".tab-content").slideUp();
				$(this).removeClass('active');
			}else{
				$(this).next(".tab-content").slideDown();
				$(this).addClass('active');
			}

		});
	}

	if($('.client-reviews-container .container').length > 0) {
		let autoplay = false;
		if($('.client-reviews-container .container').data('autoplay') == 'enabled') {
			autoplay = true;	//autoplay
		}
		$('.client-reviews-container .container').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: autoplay,
			speed: 300,
			dots: false,
			arrows: true,
			centerMode: false,
			prevArrow:'<a class="slick-arrow slick-prev ">\n' +
				'<svg xmlns="http://www.w3.org/2000/svg" width="20" height="30.777" viewBox="0 0 20 30.777">\n' +
				'  <path id="expand_more_FILL0_wght600_GRAD200_opsz20" d="M15.389,0,0,15.388,4.644,20,15.389,9.255,26.134,20l4.644-4.612Z" transform="translate(0 30.777) rotate(-90)" opacity="0.2"/>\n' +
				'</svg></a>',
			nextArrow:'<a class="slick-arrow slick-next ">\n' +
				'<svg xmlns="http://www.w3.org/2000/svg" width="20" height="30.777" viewBox="0 0 20 30.777">\n' +
				'  <path id="expand_more_FILL0_wght600_GRAD200_opsz20" d="M224.083-634.87l-15.388-15.388,4.644-4.612,10.745,10.745,10.745-10.745,4.644,4.612Z" transform="translate(654.87 239.472) rotate(-90)" opacity="0.2"/>\n' +
				'</svg></a>',
		});
	}


	if($('.site-footer .container').length > 0) {
		//get margin left of $('.site-footer .container')
		function setPromoWidth(element) {
			let footer_container_margin_left = $('.site-footer .container').css('margin-left');

			let promo_grid = $('.promo-grid');
			if(promo_grid.length > 0){
				promo_grid.css('margin-left', footer_container_margin_left);
			}
		}

		setPromoWidth();

		setTimeout(function(){
			setPromoWidth();
		}, 100);

		//trigger on resize or screen rotate
		$(window).resize(function() {
			setPromoWidth();
		});
	}

	function clickAndDrag(slider){
		if(slider) {
			let isDown = false;
			let startX;
			let scrollLeft;

			slider.addEventListener('mousedown', (e) => {
				isDown = true;
				slider.classList.add('active');
				startX = e.pageX - slider.offsetLeft;
				scrollLeft = slider.scrollLeft;
			});
			slider.addEventListener('mouseleave', () => {
				isDown = false;
				slider.classList.remove('active');
			});
			slider.addEventListener('mouseup', () => {
				isDown = false;
				slider.classList.remove('active');
			});
			slider.addEventListener('mousemove', (e) => {
				if(!isDown) return;
				$(slider).find('a').click(function(e) {
					e.preventDefault();
				});
				e.preventDefault();
				const x = e.pageX - slider.offsetLeft;
				const walk = (x - startX) * 1; //scroll-fast
				slider.scrollLeft = scrollLeft - walk;
				e.preventDefault();

				//eanble all the a tags in the slider with delay
				setTimeout(function(){
					$(slider).find('a').unbind('click');
				}, 500);
			});

			//check if a tag in slider is clicked while dragging and prevent default
			if(isDown){
				$(slider).find('a').click(function(e) {
					e.preventDefault();
				});
			}

		}
	}
	//click and drag for portfolio slider
	const portfolio_sliders = document.querySelectorAll('.portfolio-slider');
	portfolio_sliders.forEach(slider => {
		clickAndDrag(slider);
	});

	//click and drag for portfolio slider 2
	const portfolio_sliders_2 = document.querySelectorAll('.portfolio-slider-2');
	portfolio_sliders_2.forEach(slider => {
		clickAndDrag(slider);
	});

	//click and drag for our services slider
	const our_services_sliders = document.querySelectorAll('.our-services');
	our_services_sliders.forEach(slider => {
		clickAndDrag(slider);
	} );


	if($('.faq-section').length > 0) {
		$('.faq-section .faq-question').click(function() {
			$(this).toggleClass('active');
			//slide up all other answers
			$(this).siblings('.faq-answer').slideToggle();
		});

		//hide all answers on load except first
		$('.faq-section .faq-answer').hide();
		$('.faq-section .faq-answer').first().show();
	}

	let macyVar = {
		container: '.portfolio-archive',
		waitForImages: true,
		columns: 1,
		margin: 12,
		trueOrder: false,
		mobileFirst: true,
		breakAt: {
			900: {
				columns: 3,
				margin: 50,
			},
			460: {
				columns: 2,
				margin: 12,
			},
		},
	};

	//check if Macy is available
	if(typeof Macy !== 'undefined') {
		//jquery on window load

		let macyInstance = Macy(macyVar);

		let images_count = $('.portfolio-archive-container img').length;
		let img_count = 0;

		macyInstance.runOnImageLoad(function () {
			macyInstance.recalculate(true);
			macyInstance.reInit();
		}, true);

		macyInstance.on(macyInstance.constants.EVENT_RESIZE, function (ctx) {
			macyInstance.reInit();
		});

		//reinit to fix macy overlapping issue on some mobile reolutions
		$(window).on('load', function() {
			setTimeout(function(){
				macyInstance.recalculate(true);
				macyInstance.reInit();
			}, 300);
		});

		$(window).on('load', function() {
			setTimeout(function(){
				$('.portfolio-archive-container .loader-overlay').hide();
			}, 500);
		});

		//reinit on resize
		$(window).resize(function() {
			setTimeout(function(){
				macyInstance.reInit();
				macyInstance.recalculate(true);
			}, 300);
		});
	}

	//fix a bug on mobile portfolio reverse
	if($('#portfolio_slider-mobile').length > 0) {
		$('#portfolio_slider-mobile').find('.portfolio-items').each(function() {
			let children_count = $(this).children().length;
			if (children_count % 2 !== 0) {
				$(this).addClass('remove-reverse');
			}
		});
	}

	//Portfolio Filters
	$(document).ready(function() {
		const filter_trigger = $('.filter-trigger');
		if(filter_trigger.length > 0) {
			filter_trigger.click(function() {
				$('.checkbox-filter').slideToggle();
			});
		}

		$('.btn-tags-filter').click(function() {
			var checkedTags = [];
			$('input[name="tags[]"]:checked').each(function() {
				checkedTags.push($(this).val());
			});

			let current_url = $(this).data('current-url');
			let category = $(this).data('category');
			if(checkedTags.length > 0 && category !== undefined) {
				const url = current_url+ '?category=' + category + '&tags=' + encodeURIComponent(checkedTags.join('+'));
				window.location.href = encodeURI(url) ;

			}else if(category !== undefined) {
				const url = current_url + '?category=' + category;
				window.location.href = encodeURI(url) ;

			}else if(checkedTags.length > 0){
				const url = current_url + '?tags=' + encodeURIComponent(checkedTags.join('+'));
				window.location.href = url;
			}
		});

	});

	//check if lightbox is available
	if(typeof lightbox !== 'undefined') {
		lightbox.option({
			'resizeDuration': 200,
			'wrapAround': true,
			'disableScrolling': true,
		})
	}

	//show more button for portfolio mobile
	let show_more = $('.show-more');
	if(show_more.length > 0) {
		show_more.click(function() {

			if($(this).text() === 'Show Less') {
				$('.portfolio-item').each(function(index) {
					if(index > 3) {
						$(this).slideUp( "slow");
					}
				});
				$(this).text('Show More');
				return false;
			}else {
				$('.portfolio-item').each(function(index) {
					if(index > 3) {
						$(this).slideDown( "slow");
					}
				});
				$(this).text('Show Less');
				return false;
			}
		});
	}

	let show_more_mobile = $('.show-more-mobile');
	if(show_more_mobile.length > 0) {
		show_more_mobile.click(function() {

			if($(this).text() === 'Show Less') {
				$('.portfolio-items').each(function(index) {
					if(index > 1) {
						$(this).slideUp( 'slow');
					}
				});
				$(this).text('Show More');
				return false;
			}else {
				$('.portfolio-items').each(function(index) {
					if(index > 1) {
						//$(this).slideDown( 'slow');
						$(this).slideDown({
							start: function () {
								$(this).css({
									display: "flex"
								})
							}
						}, 'slow');
					}
				});
				$(this).text('Show Less');
				return false;
			}
		});
	}

	$('.search-icon svg').click(function(e) {
		// Stop propagation of the click event
		e.stopPropagation();

		$('.search-button-form').slideDown({
			start: function () {
				$(this).css({
					display: "flex"
				})
			}
		}, 'slow');

	});

	$('.search-icon-mobile svg').click(function(e) {
		// Stop propagation of the click event
		e.stopPropagation();

		$('.search-button-form').slideDown({
			start: function () {
				$(this).css({
					display: "flex"
				})
			}
		}, 'slow');

	});

//hide the form if clicked else where and check if it is visible
	$(document).click(function(e) {
		if($('.search-button-form').is(':visible') && !$(e.target).closest('.search-button-form').length) {
			$('.search-button-form').slideUp();
		}
	});

	//on the entire page loaded
	// let bg_image_loaded = false;
	// function replaceBgImage() {
	// 	if ($('.hero-section-container').length > 0) {
	// 		$('.hero-section-container').each(function() {
	// 			let bg_image_url = $(this).data('bg-replace');
	//
	// 			// Create a new Image object
	// 			let img = new Image();
	//
	// 			// Set the image source
	// 			img.src = bg_image_url;
	//
	// 			// When the image is loaded
	// 			img.onload = function() {
	// 				// Create a canvas element
	// 				let canvas = document.createElement('canvas');
	// 				let ctx = canvas.getContext('2d');
	//
	// 				// Set canvas dimensions to image dimensions
	// 				canvas.width = img.width;
	// 				canvas.height = img.height;
	//
	// 				// Draw the image onto the canvas
	// 				ctx.drawImage(img, 0, 0);
	//
	// 				// Get the Base64 data URL of the image
	// 				let base64Image = canvas.toDataURL('image/jpeg'); // You can change 'image/jpeg' to 'image/png' if needed
	//
	// 				// Set the background image using the Base64 data URL
	// 				$(this).css('background-image', 'url(' + base64Image + ')');
	// 				bg_image_loaded = true;
	// 			}.bind(this);
	// 		});
	// 	}
	//
	// }
	// //on the entire page loaded
	// $(window).on('load', function() {
	// 	replaceBgImage();
	// });
	//
	// //on interacted the page like scroll or click
	// $(window).on('scroll click', function() {
	// 	if(!bg_image_loaded) {
	// 		replaceBgImage();
	// 	}
	// });



	function stickyHeader() {
		//get the height of $('#site-header')
		let header_height = $('#site-header').outerHeight();
		let wpadminbar_height = 0;

		if($('#wpadminbar').length > 0) {
			wpadminbar_height = $('#wpadminbar').outerHeight();
		}

		$('#site-header').css('top', wpadminbar_height);
		$('#site-content').css('padding-top', (header_height-1)/10+'rem');
	}

	stickyHeader();

	//trigger on resize or screen rotate
	$(window).resize(function() {
		stickyHeader();
	});


	window.addEventListener('load', function() {
		// Get all the elements with the class 'services-cards-grid'
		let elements = document.querySelectorAll('.service-card h3');

		// Find the tallest element
		let tallestElement = 0;
		elements.forEach(function(element) {
			let currentHeight = element.clientHeight;
			if (currentHeight > tallestElement) {
				tallestElement = currentHeight;
			}
		});

		// Set the height of all the elements to the height of the tallest element
		elements.forEach(function(element) {
			element.style.height = tallestElement + 'px';
		});
	});

	//check if faq-section-container is available and the next element is faq-section-container, remove the padding bottom
	if($('.faq-section-container').length > 0) {
		$('.faq-section-container').each(function() {
			if($(this).next().hasClass('faq-section-container')) {
				$(this).css('padding-bottom', '0');
			}
		});
	}

});
